import { HEX_292D38, HEX_646A7E, HEX_7F869D, HEX_E2E5EB, HEX_E2E8F0 } from '@tanium/colors';
import { defineColor, StatusNegative, Text3 } from '@tanium/react-theme-definition';

export const TitleText = defineColor([HEX_292D38, HEX_E2E5EB]);
export const FieldLabel = defineColor([HEX_646A7E, HEX_E2E8F0]);
export const ErrorText = StatusNegative;
export const DescriptionText = Text3;

export const RequiredAsterisk = StatusNegative;
export const RequiredText = defineColor([HEX_646A7E, HEX_7F869D]);
